import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

// Import styles
import { PacketsContentLink } from './styles';

// Import variables
import { TV_PATHS } from 'components/routes/tv_routes/paths';

const { MAIN } = TV_PATHS;

function PacketLink({ title, link }) {
	const history = useHistory();
	const redirect = () => history.push(link ?? MAIN);
	return <PacketsContentLink onClick={redirect}>{title}</PacketsContentLink>;
}

PacketLink.propTypes = {
	title: PropTypes.string,
	link: PropTypes.string
};

export default PacketLink;
